import type {
  Localization,
  LocaleUrlBuilder,
} from '~/composables/types/localizable'
import type { StrapiEventListPage } from '~/composables/types/strapiEventListPage'
import { EventListPageType } from '~/composables/types/strapiEventListPage'

export const buildDynamicStrapiPageLocaleUrl = (
  localization: Localization,
  targetLocale: string,
  section: string
): string | null => {
  if (!localization.slug) return null
  const rawSlug = localization.slug.replace(/_[a-z]{2}-[a-z]{2}$/i, '')
  if (!rawSlug) return null
  return `/${targetLocale.toLowerCase()}/${section}/${rawSlug}/`
}

export const buildMagazineLocaleUrl: LocaleUrlBuilder = (
  localization: Localization,
  targetLocale: string
): string | null => {
  if (!localization.slug) return null
  return `/${targetLocale.toLowerCase()}/magazine/${localization.slug}/`
}

export const buildEventListPageLocaleUrl: LocaleUrlBuilder = (
  localization: Localization,
  targetLocale: string
): string | null => {
  const localePrefix = targetLocale.toLowerCase()
  const pageType = localization.type

  switch (pageType) {
    case EventListPageType.CITY:
      return `/${localePrefix}/${localization.citySlug}/`

    case EventListPageType.CATEGORY:
      return `/${localePrefix}/c/${localization.categorySlug}/`

    case EventListPageType.CITY_CATEGORY:
      return `/${localePrefix}/${localization.citySlug}/${localization.categorySlug}/`

    case EventListPageType.TEAMEVENT: {
      const fullSlug = localization.slug || ''
      let citySlug = fullSlug

      if (citySlug.includes('_')) {
        citySlug = citySlug.split('_')[0]
      }
      if (citySlug.startsWith('teamevent-')) {
        citySlug = citySlug.substring('teamevent-'.length)
      } else if (citySlug.startsWith('teambuilding-')) {
        citySlug = citySlug.substring('teambuilding-'.length)
      }

      if (!citySlug) return null
      return `/${localePrefix}/teamevent/${citySlug}/`
    }

    case EventListPageType.GENERAL: {
      const fullSlug = localization.slug || ''
      const slug = fullSlug.split('_')[0] || fullSlug
      return `/${localePrefix}/t/${slug}/`
    }

    case EventListPageType.KITS: {
      const kitSlug = strapiEventListPageGetters.getKitsSlug(
        localization as StrapiEventListPage
      )
      if (!kitSlug) return null
      return `/${localePrefix}/kits/${kitSlug}/`
    }

    default:
      return null
  }
}
